import { render, staticRenderFns } from "./user_data_sort.vue?vue&type=template&id=2b5bff5d&scoped=true"
import script from "./user_data_sort.vue?vue&type=script&lang=js"
export * from "./user_data_sort.vue?vue&type=script&lang=js"
import style0 from "./user_data_sort.vue?vue&type=style&index=0&id=2b5bff5d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5bff5d",
  null
  
)

export default component.exports